
<script>
    export default {
        name: "PrefixId",
        methods: {
            p( id ) {
                return this._uid + '_' + id;
            }
        }
    }
</script>

